import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
export const hasTaxonomyWriteAccess = createSelector(getScopes, scopes => scopes.includes('conversations-taxonomy-card-access'));